import "./OurGallery.module.css";
import Header from "@/reusable_sections/Header";
import GalleryHero from "./sections/GalleryHero";
import ImageGalleryGrid from "./sections/ImageGalleryGrid";
import GalleryCallToAction from "./sections/GalleryCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function OurGalleryPage() {
  return <div>
      <Header />
      <GalleryHero />
      <ImageGalleryGrid />
      <GalleryCallToAction />
      <Footer />
    </div>;
}